import React, { useState } from "react";
import { Star } from "@phosphor-icons/react";

export default function StarRating({ value, onChange, size = 32, testid = "star-rating" }) {
  const [hover, setHover] = useState(0);
  const active = hover || value;

  return (
    <div className="flex items-center gap-1.5" data-testid={testid}>
      {[1, 2, 3, 4, 5].map((n) => (
        <button
          key={n}
          type="button"
          onClick={() => onChange(n)}
          onMouseEnter={() => setHover(n)}
          onMouseLeave={() => setHover(0)}
          className="transition-transform duration-200 hover:scale-110 active:scale-95"
          data-testid={`${testid}-star-${n}`}
          aria-label={`Rate ${n} star${n > 1 ? "s" : ""}`}
        >
          <Star
            size={size}
            weight={n <= active ? "fill" : "regular"}
            className={n <= active ? "text-brand" : "text-muted-foreground/40"}
          />
        </button>
      ))}
    </div>
  );
}
